import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles(() => ({
  content: {
    padding: "0 1.875rem 0 2.5rem",
    overflowY: "auto",
  },
}));
